import { HarvestProgress } from 'common/models/growerBlock/harvestProgress';
import { UpdateLatestEstimateFormValues } from 'features/evaluation-views/types';

/** Returns default values for the estimate form */
export const createLatestEstimateFormValues = (
  progress?: HarvestProgress | null,
): UpdateLatestEstimateFormValues => ({
  estimatedBins: progress?.latestEstimate ?? null,
});
